<template>
  <div class="page flex-col">
    <div class="group_1 flex-row">
      <div class="section_2 flex-col">
        <div class="text-wrapper_1 flex-col">
          <span class="text_7">新闻中心</span>
          <span class="text_8">华为云官方发布的最新动态，为您提供关于华为云的第一手资讯</span>
        </div>
        <div class="group_2 flex-row">
          <div class="text-group_1 flex-col justify-between">
            <span class="text_9">19</span>
            <span class="text_10">03月&nbsp;2026</span>
          </div>
          <div class="group_3 flex-col"></div>
          <div class="text-group_2 flex-col justify-between">
            <span class="text_11">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_1">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_4 flex-row">
          <div class="text-group_3 flex-col justify-between">
            <span class="text_12">19</span>
            <span class="text_13">03月&nbsp;2026</span>
          </div>
          <div class="group_5 flex-col"></div>
          <div class="text-group_4 flex-col justify-between">
            <span class="text_14">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_2">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_6 flex-row">
          <div class="text-group_5 flex-col justify-between">
            <span class="text_15">19</span>
            <span class="text_16">03月&nbsp;2026</span>
          </div>
          <div class="group_7 flex-col"></div>
          <div class="text-group_6 flex-col justify-between">
            <span class="text_17">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_3">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_8 flex-row">
          <div class="text-group_7 flex-col justify-between">
            <span class="text_18">19</span>
            <span class="text_19">03月&nbsp;2026</span>
          </div>
          <div class="group_9 flex-col"></div>
          <div class="text-group_8 flex-col justify-between">
            <span class="text_20">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_4">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_10 flex-row">
          <div class="text-group_9 flex-col justify-between">
            <span class="text_21">19</span>
            <span class="text_22">03月&nbsp;2026</span>
          </div>
          <div class="group_11 flex-col"></div>
          <div class="text-group_10 flex-col justify-between">
            <span class="text_23">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_5">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_12 flex-row">
          <div class="text-group_11 flex-col justify-between">
            <span class="text_24">19</span>
            <span class="text_25">03月&nbsp;2026</span>
          </div>
          <div class="block_1 flex-col"></div>
          <div class="text-group_12 flex-col justify-between">
            <span class="text_26">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_6">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_13 flex-row">
          <div class="text-group_13 flex-col justify-between">
            <span class="text_27">19</span>
            <span class="text_28">03月&nbsp;2026</span>
          </div>
          <div class="block_2 flex-col"></div>
          <div class="text-group_14 flex-col justify-between">
            <span class="text_29">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_7">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
        <div class="group_14 flex-row">
          <img
            class="thumbnail_1"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPng16c7b74ff3379e414a2ce52df40fe0a604bac295a4dd1b2e8a8eacf1c6b1c969.png"
          />
          <div class="text-wrapper_2 flex-col"><span class="text_30">1</span></div>
          <span class="text_31">2</span>
          <span class="text_32">3</span>
          <span class="text_33">4</span>
          <span class="text_34">5</span>
          <span class="text_35">…</span>
          <span class="text_36">20</span>
          <img
            class="thumbnail_2"
            referrerpolicy="no-referrer"
            src="./assets/img/SketchPnga46564ca42166877be30b70a7aa3e61f85f2bfe32b4faf5c0999d1a226a00d90.png"
          />
        </div>
        <img
          class="image_2"
          referrerpolicy="no-referrer"
          src="./assets/img/SketchPng95c3f3d28f29c4780da50790902ffed7ef055560b206e1b3a30365941717962f.png"
        />
        <SiteFooter />
        <div class="group_16 flex-row">
          <div class="text-group_17 flex-col justify-between">
            <span class="text_43">19</span>
            <span class="text_44">03月&nbsp;2026</span>
          </div>
          <div class="section_5 flex-col"></div>
          <div class="text-group_18 flex-col justify-between">
            <span class="text_45">华为云正成为拉美多云首选，携手企业即刻领先</span>
            <span class="paragraph_9">
              2026年3月17日，华为云拉美年度旗舰盛会COMPASS峰会在深圳与东莞召开。本次大会汇聚来自拉美超150位公共事业机构、头部企业、行业专家与技术伙伴等,
              <br />
              沉浸式体验中国最前沿的科技创新成果，共同见证人工智能与日常生活的融合，探索云技术赋能美好未来.
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SiteFooter from '@/components/SiteFooter.vue';

export default {
  components: { SiteFooter },
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="less" src="./assets/index.less" />